import { useQuery } from "@tanstack/react-query";
import { PagedResponse } from "src/utils/types";
import { axiosCompanyInstance } from "src/config/axios";

export const RQ_SEARCH_BAR_KEY = "SEARCH_BAR_KEY";

export interface SearchBarResponseItem {
    id: string;
    type: "companycustomer" | "station" | "location" | "tariff" | "companyuser";
    content: string;
    updatedAt: string;
}

export type SearchBarFilters = {
    search?: string;
};

export const useSearchBarAutocomplete = (searchPhrase: string) => {
    return useQuery({
        queryKey: [RQ_SEARCH_BAR_KEY, searchPhrase],
        queryFn: async (): Promise<PagedResponse<SearchBarResponseItem[]> | null> => {
            if (searchPhrase) {
                const res = await axiosCompanyInstance.get(`search`, {
                    params: { search: searchPhrase, page: 1 },
                });

                return res?.data || null;
            }
            return null;
        },
        enabled: false,
    });
};
